import {
    Base
} from "//www.greenwellfarms.com/cdn/shop/t/53/assets/base.js?v=169946323862693207411733340615";
class PredictiveSearch extends Base {
    constructor() {
        super();
    }

    init(selector) {

        if ("undefined" === typeof selector || null === selector) return this;
        this.set("el", selector);
        return this.prep();

    } //

    prep() {
        let the_item = this.get("el"),
            input = the_item.querySelector('input[type="search"]'),
            pre_search_results = the_item.querySelector('[data-predictive-search]'),
            form = the_item.querySelector('form.search'),
            status_element = the_item.querySelector('.predictive-search-status'),
            loading_text = the_item.getAttribute('data-loading-text'),
            selected_element = the_item.querySelector('[aria-selected="true"]'),
            all_elements = the_item.querySelectorAll('li'),
            active_element = the_item.querySelector('li'),
            cached_results = {};
     
        this.set("cached_results", cached_results);
        the_item.input = input;
        the_item.form = form;
        the_item.status_element = status_element;
        the_item.loading_text = loading_text;
        the_item.pre_search_results = pre_search_results;
        the_item.selected_element = selected_element;
        the_item.all_elements = all_elements;
        the_item.active_element = active_element;
        return this.bind_events();

    } // 

    bind_events() {
        let the_item = this.get("el"),
            form = the_item.form,
            input = the_item.input,
            pre_search_results = the_item.pre_search_results;

        form.addEventListener('submit', this.handle_form_submit.bind(this));
        input.addEventListener('input', this.debounce((event) => {
            this.hande_input_change(event);
        }, 300).bind(this));

        the_item.addEventListener('focus', this.handle_input_focus.bind(this));
        the_item.addEventListener('focusout', this.handle_input_focusout.bind(this));
        the_item.addEventListener('keyup', this.handle_input_keyup.bind(this));
        the_item.addEventListener('keydown', this.handle_input_keydown.bind(this));

        return this;
    }

    get_value() {
        return this.get("el").input.value.trim();
    }

    handle_form_submit(event) {
        let the_item = this.get("el");

        if (!this.get_value().length || the_item.querySelector('[aria-selected="true"] a')) event.preventDefault();

        return this;
    }

    hande_input_change() {
        let search_term = this.get_value();
    
        if (!search_term.length) {
          this.close(true);
          return this;
        }
    
        this.getSearchResults(search_term);

        return this;
    }

    handle_input_focus() {

        let search_term = this.get_value();
    
        if (!search_term.length) return this;
    
        if (this.getAttribute('results') === 'true') {
          this.open();
        } else {
          this.getSearchResults(search_term);
        }

        return this;
    }

    handle_input_focusout() {
        let the_item = this.get("el"),
            active_element = the_item.active_element;

        setTimeout(() => {
          if (!active_element) return this.close();
        })

        return this;
    }

    handle_input_keyup(event) {

        if (!this.get_value().length) this.close(true);
        event.preventDefault();
    
        switch (event.code) {
          case 'ArrowUp':
            this.switchOption('up')
            break;
          case 'ArrowDown':
            this.switchOption('down');
            break;
          case 'Enter':
            this.selectOption();
            break;
        }
        
        return this;
    }

    handle_input_keydown(event) {
        // Prevent the cursor from moving in the input when using the up and down arrow keys
        if (
          event.code === 'ArrowUp' ||
          event.code === 'ArrowDown'
        ) {
          event.preventDefault();
        }
        return this;
    }

    switchOption(direction) {
        let the_item = this.get("el"),
            move_up = direction === 'up',
            input = the_item.input,
            status_element = the_item.status_element,
            selected_element = the_item.selected_element,
            all_elements = the_item.all_elements,
            active_element = the_item.active_element;

        if (!the_item.getAttribute('open')) return this;
    
        if (move_up && !selected_element) return this;
    
        status_element.textContent = '';
    
        if (!move_up && selected_element) {
            active_element = selected_element.nextElementSibling || all_elements[0];
        } else if (move_up) {
            active_element = selected_element.previousElementSibling || all_elements[all_elements.length - 1];
        }
    
        if (active_element === selected_element) return this;
    
        active_element.setAttribute('aria-selected', true);
        if (selected_element) selected_element.setAttribute('aria-selected', false);
    
        this.setLiveRegionText(active_element.textContent);
        input.setAttribute('aria-activedescendant', active_element.id);
        
        return this;
    }

    selectOption() {
        let the_item = this.get("el")
            selectedProduct = the_item.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');
    
        if (selectedProduct) selectedProduct.click();

        return this;
    }

    getSearchResults(search_term) {

        let the_item = this.get("el"),
            query_key = search_term.replace(" ", "-").toLowerCase(),
            cached_results = this.get("cached_results");
        this.setLiveRegionLoadingState();
    
        if (cached_results[query_key]) {
            return this.renderSearchResults(cached_results[query_key]);
        }

        fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(search_term)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=4&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                var error = new Error(response.status);
                this.close();
                throw error;
                }

                return response.text();
            })
            .then((text) => {
                let results_markup = new DOMParser().parseFromString(text, 'text/html').getElementById('shopify-section-predictive-search').innerHTML;
                cached_results[query_key] = results_markup;
                this.set("cached_results", cached_results);
                this.renderSearchResults(results_markup);
            })
            .catch((error) => {
                this.close();
                throw error;
            });

        return this;
    }

    setLiveRegionLoadingState() {
        let the_item = this.get("el"),
            loading_text = the_item.loading_text;

        this.setLiveRegionText(loading_text);
        the_item.setAttribute('loading', true);

        return this;
    }

    setLiveRegionText(status_text) {
        let the_item = this.get("el"),
            status_element = the_item.status_element;

        status_element.setAttribute('aria-hidden', 'false');
        status_element.textContent = status_text;
    
        setTimeout(() => {
            status_element.setAttribute('aria-hidden', 'true');
        }, 1000);

        return this;
    }

    renderSearchResults(results_markup) {

        let the_item = this.get("el"),
            pre_search_results = the_item.pre_search_results;

        pre_search_results.innerHTML = results_markup;
        the_item.setAttribute('results', true);
    
        this.setLiveRegionResults();
        this.open();

        return this;
    }

    setLiveRegionResults() {
        let the_item = this.get("el");

        the_item.removeAttribute('loading');
        this.setLiveRegionText(the_item.querySelector('[data-predictive-search-live-region-count-value]').textContent);

        return this;
    }

    getResultsMaxHeight() {
        let results_max_height = window.innerHeight - document.querySelector('#shopify-section-header').getBoundingClientRect().bottom;
        return this.set("results_max_height", results_max_height);
    }

    open() {

        let the_item = this.get("el"),
            pre_search_results = the_item.pre_search_results;

        this.getResultsMaxHeight();
        pre_search_results.style.maxHeight = `${this.get("results_max_height")}px`;

        the_item.setAttribute('open', true);
        the_item.input.setAttribute('aria-expanded', true);

        return this;
    }

    close(clear_search_term = false) {
        let the_item = this.get("el"),
            input = the_item.input,
            pre_search_results = the_item.pre_search_results;

        if (clear_search_term) {
            input.value = '';
            the_item.removeAttribute('results');
        }
    
        let selected = the_item.querySelector('[aria-selected="true"]');
    
        if (selected) selected.setAttribute('aria-selected', false);
    
        input.setAttribute('aria-activedescendant', '');
        the_item.removeAttribute('open');
        input.setAttribute('aria-expanded', false);
        this.set("results_max_height", false);
        pre_search_results.removeAttribute('style');
    
    }

}

export {
    PredictiveSearch
};